import Cookies from 'js-cookie'

import { AvgConsentLevel } from '@app-enums'
import { CONSENT_LEVEL_COOKIE_KEY_BASE, cookieExpires } from './cookie-modal.config'

const getCookieExpiresForConsentLevel = (consentLevel: AvgConsentLevel): number => {
    if (consentLevel === AvgConsentLevel.NECESSARY) {
        return cookieExpires.ONE_MONTH
    }

    if (consentLevel === AvgConsentLevel.PREFERENCES) {
        return cookieExpires.ONE_MONTH
    }

    if (consentLevel === AvgConsentLevel.STATISTICS) {
        return cookieExpires.ONE_MONTH
    }

    if (consentLevel === AvgConsentLevel.MARKETING) {
        return cookieExpires.ONE_MONTH
    }

    return cookieExpires.ONE_MONTH
}

export const setConsentLevel = (consentLevel: AvgConsentLevel): void => {
    const key = CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + consentLevel.toString()

    Cookies.set(key, 'granted', {
        expires: getCookieExpiresForConsentLevel(consentLevel),
    })
}

export const rejectConsentLevel = (consentLevel: AvgConsentLevel): void => {
    const key = CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + consentLevel.toString()

    Cookies.set(key, 'denied', {
        expires: getCookieExpiresForConsentLevel(consentLevel),
    })
}

export const rejectAllConsentLevels = (): void => {
    setConsentLevel(AvgConsentLevel.NECESSARY)
    rejectConsentLevel(AvgConsentLevel.PREFERENCES)
    rejectConsentLevel(AvgConsentLevel.STATISTICS)
    rejectConsentLevel(AvgConsentLevel.MARKETING)
}

export const setAllConsentLevels = (): void => {
    setConsentLevel(AvgConsentLevel.NECESSARY)
    setConsentLevel(AvgConsentLevel.PREFERENCES)
    setConsentLevel(AvgConsentLevel.STATISTICS)
    setConsentLevel(AvgConsentLevel.MARKETING)
}

export const allConsentLevelsAreSetInCookies = (): boolean => {
    const necessary = Cookies.get(CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + AvgConsentLevel.NECESSARY.toString()) !== undefined
    const preferences = Cookies.get(CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + AvgConsentLevel.PREFERENCES.toString()) !== undefined
    const statistics = Cookies.get(CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + AvgConsentLevel.STATISTICS.toString()) !== undefined
    const marketing = Cookies.get(CONSENT_LEVEL_COOKIE_KEY_BASE + '-' + AvgConsentLevel.MARKETING.toString()) !== undefined

    return necessary && preferences && statistics && marketing
}